<template>
  <h2 class="card-title">Instructions</h2>
  <div class="text-start">
    <p>Welcome to the Pacific Island Reference Map!</p>

    <h3 class="my-4"><i class="bi bi-globe-americas"></i> Introduction</h3>
    <p>
      This interactive map allows you to explore the Pacific Islands, their
      cultural regions, and historical migration patterns. Learn about
      Polynesia, Melanesia, Micronesia, and the fascinating journeys that shaped
      Pacific island cultures.
    </p>

    <h3 class="my-4"><i class="bi bi-map"></i> Exploring the Map</h3>
    <ol class="list-group list-group-numbered">
      <li class="list-group-item">
        <strong>Select Islands:</strong> Click any island marker on the map or
        choose an island from the <strong>Islands</strong> list in the sidebar
        to view detailed information.
      </li>
      <li class="list-group-item">
        <strong>Explore Areas:</strong> Select items from the
        <strong>Areas &amp; Regions</strong> list (marked with
        <i class="bi bi-bounding-box"></i>) to explore cultural regions like
        Polynesia, Melanesia, and Micronesia, or migration waves. Selecting an
        area will automatically activate its layer on the map.
      </li>
      <li class="list-group-item">
        <strong>Navigate:</strong> Use your mouse or touch gestures to pan,
        zoom, and rotate the map. Click the <strong>Home</strong> button to
        reset your view.
      </li>
    </ol>

    <h3 class="my-4"><i class="bi bi-layers-fill"></i> Using Map Layers</h3>
    <p>
      The <strong>Map Tools</strong> panel (located in the top-left of the map)
      lets you toggle different layers to reveal additional information:
    </p>
    <ul class="list-group">
      <li class="list-group-item">
        <strong>None:</strong> Shows only island markers with no overlay layers.
      </li>
      <li class="list-group-item">
        <strong>Cultural:</strong> Displays the three major cultural regions
        (Polynesia, Melanesia, Micronesia) as colored overlays. Click on a
        region to learn more about it.
      </li>
      <li class="list-group-item">
        <strong>Migration Wave 1:</strong> Shows the first human migration into
        the Pacific (~50,000 – 10,000 BCE), including routes and settlement
        areas.
      </li>
      <li class="list-group-item">
        <strong>Migration Wave 2:</strong> Shows the Austronesian/Lapita
        expansion (~5,000 BCE – 800 CE), which spread across Remote Oceania.
      </li>
    </ul>
    <p class="mt-3 text-muted small">
      <i class="bi bi-info-circle"></i> Tip: When you select an area from the
      list, the corresponding layer is automatically activated. You can also
      manually switch layers using the Map Tools panel.
    </p>

    <h3 class="my-4">
      <i class="bi bi-trophy-fill"></i> Completing the Activity
    </h3>
    <ol class="list-group list-group-numbered">
      <li class="list-group-item">
        Explore different islands and regions to learn about Pacific Island
        geography, culture, and history.
      </li>
      <li class="list-group-item">
        After completing the activity, click the <strong>Submit</strong> button.
      </li>
      <li class="list-group-item">
        You will be presented with a certificate of completion to acknowledge
        your engagement with the material.
      </li>
      <li class="list-group-item">
        Click the <strong>Download</strong> button to save a copy on your
        computer which you can submit to Canvas.
      </li>
    </ol>

    <h3 class="my-4"><i class="bi bi-universal-access"></i> Accessibility</h3>
    <p>
      Our application is designed to be fully compliant with the WCAG AA 2.0
      Standards. You can navigate all features using keyboard controls.
    </p>
  </div>
</template>

<script>
export default {
  name: "UserInstructions"
};
</script>
